(function () {
  function renderGallery(root, gallery) {
    const main = root.querySelector('[data-gallery-main]');
    const thumbs = root.querySelector('[data-gallery-thumbs]');
    if (!main || !thumbs || !gallery || !gallery.length) return;

    const first = gallery[0];
    const prev = main.querySelector('[data-gallery-prev]');
    const next = main.querySelector('[data-gallery-next]');
    const count = main.querySelector('[data-gallery-count]');
    main.innerHTML = `<img src="${first.src}" alt="${first.alt || ''}" loading="eager">
      ${prev ? prev.outerHTML : '<button class="gallery-arrow-v1 left" type="button" data-gallery-prev aria-label="Previous image">‹</button>'}
      ${next ? next.outerHTML : '<button class="gallery-arrow-v1 right" type="button" data-gallery-next aria-label="Next image">›</button>'}
      <div class="gallery-count-v1" data-gallery-count>${gallery.length ? `01 / ${String(gallery.length).padStart(2, '0')}` : '01'}</div>
      <div class="pixel-corners"></div>`;
    thumbs.innerHTML = gallery.map((image, index) => {
      const active = index === 0 ? ' is-active' : '';
      return `<button class="gallery-thumb${active}" type="button" data-full="${image.src}" data-alt="${image.alt || ''}">
        <img src="${image.thumb}" alt="${image.alt || ''}" loading="lazy">
      </button>`;
    }).join('');
  }

  function bindThumbs(root) {
    const main = root.querySelector('[data-gallery-main]');
    const thumbs = root.querySelector('[data-gallery-thumbs]');
    if (!main || !thumbs) return;

    function setActive(button) {
      thumbs.querySelectorAll('.gallery-thumb').forEach((thumb) => thumb.classList.remove('is-active'));
      button.classList.add('is-active');
      const prev = main.querySelector('[data-gallery-prev]');
      const next = main.querySelector('[data-gallery-next]');
      const count = main.querySelector('[data-gallery-count]');
      const all = Array.from(thumbs.querySelectorAll('.gallery-thumb'));
      const index = all.indexOf(button);
      const total = all.length;
      main.innerHTML = `<img src="${button.dataset.full}" alt="${button.dataset.alt || ''}" loading="eager">
        ${prev ? prev.outerHTML : '<button class="gallery-arrow-v1 left" type="button" data-gallery-prev aria-label="Previous image">‹</button>'}
        ${next ? next.outerHTML : '<button class="gallery-arrow-v1 right" type="button" data-gallery-next aria-label="Next image">›</button>'}
        <div class="gallery-count-v1" data-gallery-count>${String(index + 1).padStart(2, '0')} / ${String(total).padStart(2, '0')}</div>
        <div class="pixel-corners"></div>`;
    }

    thumbs.addEventListener('click', function (event) {
      const button = event.target.closest('.gallery-thumb');
      if (!button) return;
      setActive(button);
    });

    main.addEventListener('click', function (event) {
      const direction = event.target.closest('[data-gallery-prev], [data-gallery-next]');
      if (!direction) return;
      const all = Array.from(thumbs.querySelectorAll('.gallery-thumb'));
      if (!all.length) return;
      const current = thumbs.querySelector('.gallery-thumb.is-active') || all[0];
      const currentIndex = all.indexOf(current);
      const nextIndex = direction.matches('[data-gallery-prev]')
        ? (currentIndex - 1 + all.length) % all.length
        : (currentIndex + 1) % all.length;
      setActive(all[nextIndex]);
    });
  }

function initProductDisplay(section) {
  const script = document.querySelector(`[data-variant-gallery-json="${section.dataset.sectionId}"]`);
  bindThumbs(section);
  initStoryCarousel(section);
  if (!script) return;

  let data;
  try {
    data = JSON.parse(script.textContent);
  } catch (error) {
    return;
  }

  section.querySelectorAll('[data-variant-button]').forEach((button) => {
    button.addEventListener('click', function () {
      const variantId = Number(button.dataset.variantId);
      const variant = data.variants.find((item) => Number(item.id) === variantId);
      if (!variant) return;

      section.querySelectorAll('[data-variant-button]').forEach((item) => item.classList.remove('is-active'));
      button.classList.add('is-active');

      const priceTarget = section.querySelector('.product-price-v1 strong');
      if (priceTarget && button.dataset.variantPrice) {
        priceTarget.textContent = button.dataset.variantPrice;
      }

      renderGallery(section, variant.gallery);
    });
  });
}


  function initStoryCarousel(section) {
    const carousel = section.querySelector('[data-product-story-carousel]');
    const script = document.querySelector(`[data-story-gallery-json="${section.dataset.sectionId}"]`);
    if (!carousel || !script) return;

    let data;
    try {
      data = JSON.parse(script.textContent);
    } catch (error) {
      return;
    }

    const images = Array.isArray(data.images) ? data.images.filter((image) => image && image.src) : [];
    const image = carousel.querySelector('[data-story-image]');
    const prev = carousel.querySelector('[data-story-prev]');
    const next = carousel.querySelector('[data-story-next]');
    const count = carousel.querySelector('[data-story-count]');
    if (!image || !images.length) return;

    let currentIndex = Math.min(1, images.length - 1);

    function render(index) {
      currentIndex = (index + images.length) % images.length;
      image.src = images[currentIndex].src;
      image.alt = images[currentIndex].alt || '';
      if (count) count.textContent = `${currentIndex + 1} / ${images.length}`;
    }

    if (images.length < 2) {
      if (prev) prev.hidden = true;
      if (next) next.hidden = true;
      if (count) count.hidden = true;
      render(0);
      return;
    }

    if (prev) prev.addEventListener('click', () => render(currentIndex - 1));
    if (next) next.addEventListener('click', () => render(currentIndex + 1));
    render(currentIndex);
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-product-display]').forEach(initProductDisplay);
  });
})();

// Preserve Shopify preview/theme-editor query parameters on internal V1 links.
document.addEventListener('click', function (event) {
  const link = event.target.closest('a[href]');
  if (!link) return;
  const rawHref = link.getAttribute('href');
  if (!rawHref || rawHref === '#' || rawHref.startsWith('#') || rawHref.startsWith('mailto:') || rawHref.startsWith('tel:')) return;
  if (link.target === '_blank' || rawHref.startsWith('http://') || rawHref.startsWith('https://')) return;

  const current = new URL(window.location.href);
  const target = new URL(rawHref, window.location.origin);
  const preserveKeys = ['preview_theme_id', '_ab', '_fd', 'pb', 'preview_key'];
  let changed = false;
  preserveKeys.forEach(function (key) {
    if (current.searchParams.has(key) && !target.searchParams.has(key)) {
      target.searchParams.set(key, current.searchParams.get(key));
      changed = true;
    }
  });

  if (changed) {
    event.preventDefault();
    window.location.href = target.pathname + target.search + target.hash;
  }
}, true);
